/**
 * @generated SignedSource<<7ce633ca49f0810e2211dc88c2dc054a>>
 * @relayHash eaf07a2f7c8c5668f3e30f1f572c3bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98cbf5f1e9f76cc9982fffc4532e3c143481d635ebb65948dd688e2cea6a1295

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "98cbf5f1e9f76cc9982fffc4532e3c143481d635ebb65948dd688e2cea6a1295",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
